const state = {
    isLoading: false,
    selectedWidgetOptions: [],
};

const mutations = {
    SET_IS_LOADING(state, val) {
        state.isLoading = val;
    },

    SET_SELECTED_WIDGET_DATA(state, { widgetId, selectedOption }) {
        let widgetOption = state.selectedWidgetOptions.find(w => w.widgetId === widgetId);
        if (widgetOption) {
            widgetOption.selectedOption = selectedOption;
        } else {
            state.selectedWidgetOptions.push({ widgetId, selectedOption });
        }
    },
};

const getters = {
    getSelectedOptionById: state => id => {
        let widgetOption = state.selectedWidgetOptions.find(w => w.widgetId === id);
        if (widgetOption) {
            return widgetOption.selectedOption;
        }
        return '';
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
};
